import { render, staticRenderFns } from "./salary_resign_6.vue?vue&type=template&id=6e862541&scoped=true"
import script from "./salary_resign_6.vue?vue&type=script&lang=ts"
export * from "./salary_resign_6.vue?vue&type=script&lang=ts"
import style0 from "./salary_resign_6.vue?vue&type=style&index=0&id=6e862541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e862541",
  null
  
)

export default component.exports